var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.selected.length > 0
        ? _c(
            "div",
            { staticClass: "mb-1 d-flex flex-wrap" },
            _vm._l(_vm.selected, function(tag, index) {
              return _c(
                "span",
                {
                  key: tag.id,
                  staticClass: "custom-tag mr-1",
                  style: _vm.getBadgeStyle(tag.color)
                },
                [
                  _c("span", { staticClass: "mr-1" }, [
                    _vm._v(_vm._s(tag.name))
                  ]),
                  _vm._v(" "),
                  !_vm.isDisabled
                    ? _c("font-awesome-icon", {
                        staticStyle: { cursor: "pointer" },
                        attrs: { icon: "times" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.removeTag(index)
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-input-group",
        { staticClass: "position-relative" },
        [
          _c("b-form-input", {
            attrs: {
              id: "input-recruit-tags",
              size: "sm",
              disabled: _vm.isDisabled,
              placeholder: "Поиск тега",
              autocomplete: "off"
            },
            on: { focus: _vm.onFocusIn, blur: _vm.onFocusOut },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          }),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.isDisabled
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onClearSelected.apply(null, arguments)
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isFocus
            ? _c(
                "b-list-group",
                {
                  staticClass:
                    "autocomplete-input position-absolute w-100 shadow-sm",
                  staticStyle: {
                    "z-index": "1050",
                    top: "0",
                    "max-height": "200px",
                    "overflow-y": "auto"
                  }
                },
                [
                  _vm._l(_vm.filteredItems, function(item) {
                    return _c(
                      "b-list-group-item",
                      {
                        key: item.id,
                        staticClass: "text-small",
                        attrs: { button: "" },
                        on: {
                          mousedown: function($event) {
                            $event.preventDefault()
                            return _vm.selectTag(item)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "custom-tag mr-1",
                            style: _vm.getBadgeStyle(item.color)
                          },
                          [
                            _c("span", { staticClass: "mr-1" }, [
                              _vm._v(_vm._s(item.name))
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.filteredItems.length === 0 && _vm.query
                    ? _c("b-list-group-item", { attrs: { disabled: "" } }, [
                        _c("small", [_vm._v("Ничего не найдено")])
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc2b3508", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc2b3508","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/RecruitTags/RecruitTagMultiSelect.vue
// module id = null
// module chunks = 